import { useQuery } from '@tanstack/react-query';
import { leaveService } from '@/services/leave/leaveService';
import { leaveQueryKeys } from './queryKeys';

export const useMyLeaveRequests = (profileId: string) => {
  return useQuery({
    queryKey: leaveQueryKeys.myRequests(profileId),
    queryFn: () => leaveService.getMyLeaveRequests(profileId),
    enabled: !!profileId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
